// Hardcoded video IDs from PD Buddy YouTube channel.
// Replace with YouTube Data API fetch in the future.
export class YouTubeContent {
  public static readonly WEBINAR_VIDEOS = [
    {
      id: 'dQw4w9WgXcQ',
      title: 'Latest PD Buddy Webinar',
      publishedAt: '2024-01-01T00:00:00.000Z',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: "Understanding Parkinson's Disease",
      publishedAt: '2023-12-01T00:00:00.000Z',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'Living Well with PD',
      publishedAt: '2023-11-01T00:00:00.000Z',
    },
    {
      id: 'dQw4w9WgXcQ',
      title: 'Exercise & Movement Strategies',
      publishedAt: '2023-10-01T00:00:00.000Z',
    },
  ] as const

  public static readonly MICHEL_HACKS = [
    {
      id: 'eCTBeKZk7xw',
      title: 'Insomnia',
      description: "Tips for better sleep with Parkinson's",
      isShort: true,
    },
    {
      id: 'E-CGYXJpnU0',
      title: 'Constipation',
      description: 'Managing digestive issues with PD',
      isShort: true,
    },
    {
      id: 'eCTBeKZk7xw',
      title: 'Coming Soon',
      description: 'More PD hacks from Michel',
      isShort: true,
    },
    {
      id: 'E-CGYXJpnU0',
      title: 'Coming Soon',
      description: 'More PD hacks from Michel',
      isShort: true,
    },
    {
      id: 'eCTBeKZk7xw',
      title: 'Coming Soon',
      description: 'More PD hacks from Michel',
      isShort: true,
    },
    {
      id: 'E-CGYXJpnU0',
      title: 'Coming Soon',
      description: 'More PD hacks from Michel',
      isShort: true,
    },
  ] as const

  public static readonly YOUTUBE_CHANNEL_URL =
    'https://www.youtube.com/@nosilverbullet4pd998/shorts'
}

export const WEBINAR_VIDEOS = YouTubeContent.WEBINAR_VIDEOS
export const MICHEL_HACKS = YouTubeContent.MICHEL_HACKS
export const YOUTUBE_CHANNEL_URL = YouTubeContent.YOUTUBE_CHANNEL_URL
